import { combineReducers } from 'redux';

import awsTokenReducer from './awsTokenReducer';
import languageReducer from './languageReducer';
import userReducer from './userReducer';

export default combineReducers({
    awsToken: awsTokenReducer,
    lang: languageReducer,
    user: userReducer,
});
